exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MobileAppLinkSender-title{font-size:15px;margin-bottom:18px}.MobileAppLinkSender-button{text-align:end}.MobileAppLinkSender .PhoneNumberField-country-code{background-color:var(--surface-backgroundPrimary);margin:0;-webkit-padding-start:16px;padding-inline-start:16px}.MobileAppLinkSender .PhoneNumberField-field{margin-bottom:17px}.MobileAppLinkSender .PhoneNumberField-consent-text{width:262px}", ""]);

// exports
